"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.forEachRichTextElement = forEachRichTextElement;
exports.assignMissingInterpolatedInlineOptionIds = assignMissingInterpolatedInlineOptionIds;
exports.inlineOptionElementToOption = inlineOptionElementToOption;
exports.findInterpolatedInlineOptionById = findInterpolatedInlineOptionById;
/**
 * Walk all nested rich-text elements (paragraphs, conditionals, etc.).
 */
function forEachRichTextElement(elements, visit) {
    if (!elements)
        return;
    for (const element of elements) {
        visit(element);
        if (element.type === 'conditional') {
            forEachRichTextElement(element.children, visit);
            forEachRichTextElement(element.elseChildren, visit);
        }
        else if (Array.isArray(element.content)) {
            forEachRichTextElement(element.content, visit);
        }
    }
}
/**
 * Inline options authored in .ad files get optionId during AdventureParser pass.
 * Options produced only after description interpolation (script → &lt;option:...&gt;) never get ids;
 * assign stable ids so the frontend InlineOption and selectOption can resolve them.
 */
function assignMissingInterpolatedInlineOptionIds(description, sceneId, sectionIndex) {
    if (!description || typeof description === 'string' || !description.elements?.length) {
        return;
    }
    let next = 0;
    forEachRichTextElement(description.elements, (el) => {
        if (el.type !== 'inline-option')
            return;
        const cur = el.optionId;
        if (cur !== undefined && cur !== null && String(cur).trim() !== '')
            return;
        el.optionId = `${sceneId}_section${sectionIndex}_idyn_${next}`;
        next += 1;
    });
}
function renderInlineOptionPlainText(content) {
    if (!content || !Array.isArray(content))
        return '';
    return content
        .map((element) => {
        if (element.type === 'text') {
            return typeof element.content === 'string' ? element.content : '';
        }
        if (element.type === 'bold' || element.type === 'italic') {
            return renderInlineOptionPlainText(Array.isArray(element.content) ? element.content : undefined);
        }
        if (element.type === 'image') {
            return `[${element.imageType ?? 'image'}]`;
        }
        if (Array.isArray(element.content)) {
            return renderInlineOptionPlainText(element.content);
        }
        return '';
    })
        .join('');
}
function inlineOptionElementToOption(element) {
    if (element.type !== 'inline-option')
        return undefined;
    const id = String(element.optionId ?? '').trim();
    const target = String(element.target ?? '').trim();
    if (!id || !target)
        return undefined;
    return {
        id,
        text: renderInlineOptionPlainText(Array.isArray(element.content) ? element.content : undefined),
        target,
        ...(element.effects ? { effect: element.effects } : {}),
        ...(element.condition ? { condition: element.condition } : {}),
    };
}
/**
 * Resolve an inline option that exists only on the interpolated scene (e.g. script-generated hub links).
 */
function findInterpolatedInlineOptionById(interpolatedScene, optionId) {
    const want = String(optionId ?? '').trim();
    if (!want)
        return undefined;
    for (const section of interpolatedScene.sections ?? []) {
        const desc = section.description;
        if (!desc || typeof desc === 'string' || !desc.elements?.length)
            continue;
        let found;
        forEachRichTextElement(desc.elements, (el) => {
            if (found)
                return;
            if (el.type !== 'inline-option')
                return;
            if (String(el.optionId ?? '').trim() === want) {
                found = el;
            }
        });
        if (found) {
            return inlineOptionElementToOption(found);
        }
    }
    return undefined;
}
//# sourceMappingURL=interpolatedInlineOptions.js.map